import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UsersService } from 'src/app/_services/admin/users.service';

import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { MixpanelService } from 'src/app/_services/mixpanel.service';
import { TasksService } from 'src/app/_services/tasks.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
@Component({
    selector: 'app-add-member',
    templateUrl: './add-member.component.html',
    styleUrls: ['./add-member.component.scss'],
    standalone: false
})
export class AddMemberComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  users : any[] = [];
  showDropdown!: boolean;
  showNoUser!: boolean;
  selectedUsers : any[] = [];
  searchUserVal: any;
  submitTouched : boolean = false;
  data: any;
  title: any
  translate: any;
  
  constructor(private userService: UsersService,
    private taskService : TasksService,
    public modalRef : BsModalRef,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
    private mixPanelService: MixpanelService  
  ) {
    super();
    this.getLanguageData()}

  ngOnInit() {
  }

  getSearchedUserList(event: any){
    console.log(event, "===",this.searchUserVal)
    if(event){
      this.userService.getUsersBySearch(event.query).subscribe(users => {
        this.users = users;
        if(this.users.length){
          this.showDropdown = true;
          this.showNoUser = false;
        } else {
          this.showNoUser = true;
        }
      });
    } else{
      this.showDropdown = false;
    }
  }  

  addUser(userData: any){
    var user = userData.value ? userData.value : userData;
    console.log(user)
    this.searchUserVal = user
    this.selectedUsers = [];
    this.selectedUsers.push(user);
  }

  removeUser(){
    console.log("we are removing data")
    this.selectedUsers = [];
  }

  onSubmit(){
    this.submitTouched == true;
    this.taskService.addMemberToTask(this.data, this.selectedUsers[0]).subscribe((res: any) => {
      if(res.status == 200 || res.status == 201){
        console.log("member aaded");
        //Mixpanel Event Tracking
        if(localStorage.getItem('packageCode') != null && localStorage.getItem('packageCode') != 'Old'){
          this.mixPanelService.track('w_task_view_add_member', { propertyName: 'w_task_view_add_member', method: 'button_click'});
        }
        this.modalRef.hide();
       this.errorUtil.setErrorMessage(200, null ,  this.translate?.general.messages.savedSuccessfully, 'success',1000);
        } else {
          this.errorUtil.setErrorMessage(res.status, null ,  res.error.title, 'error',3000);
      }
    },
    (err) => {
      console.log(err)
     const title = this.errorUtil.processErrorTitle(err.error,this.translate)
     this.errorUtil.setErrorMessage(400, null ,  title, 'error',3000);
    
  });
  }

  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      }
    }))
    console.log("translate",this.translate)
   // this.mainLabel = this.translate?.accessories.label.plural
  }

  push(obs:any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}
